import React from "react";
import { Box, Paper, Stack, Typography } from "@mui/material";

export type MediaKitSettingsSectionProps = {
  title: string;
  description?: React.ReactNode;
  icon?: React.ReactNode;
  action?: React.ReactNode;
  children: React.ReactNode;
};

/** Sans-serif section title shared by the settings sections and the share panel. */
export const MediaKitSectionTitle: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <Typography
    variant="body1"
    component="h3"
    sx={{ fontWeight: 600, lineHeight: 1.4 }}
  >
    {children}
  </Typography>
);

export const MediaKitSettingsSection: React.FC<
  MediaKitSettingsSectionProps
> = ({ title, description, icon, action, children }) => (
  <Paper variant="outlined" sx={{ p: { xs: 2, sm: 2.5 }, borderRadius: 2 }}>
    <Stack
      direction="row"
      spacing={1.5}
      alignItems="flex-start"
      justifyContent="space-between"
      sx={{ mb: 2 }}
    >
      <Stack direction="row" spacing={1.25} alignItems="flex-start">
        {icon ? (
          <Box sx={{ color: "text.secondary", display: "flex", pt: 0.25 }}>
            {icon}
          </Box>
        ) : null}
        <Box>
          <MediaKitSectionTitle>{title}</MediaKitSectionTitle>
          {description ? (
            <Typography variant="body2" color="text.secondary">
              {description}
            </Typography>
          ) : null}
        </Box>
      </Stack>
      {action}
    </Stack>
    {children}
  </Paper>
);
